import React from "react";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import useCalc from "@/hooks/calculator.ts";
import styles from "@/styles/HomeUserCalc.module.scss";
import CalculatorLimitTypes from "@/types_and_interfaces/calculator_limit_types.ts";
import CalculatorLimit from "@/types_and_interfaces/calculator_limit.ts";

interface SwitcherProps {
    styles: any
}


const SwitcherMobile: React.FC<SwitcherProps> = ({styles}) => {
    const calc = useCalc()
    
    
    return (
        <div className={styles.switcher_mobile}>
            
            {(() => {
                const types: CalculatorLimitTypes | {} | undefined = calc.get_types();
                
                if (!types || Object.keys(types).length === 0) {
                    return [{}, {}, {}].map((obj, i) => (
                        <TypeSwitcher key={"CrTypeSwitcher" + i} obj={obj} />
                    ));
                }
                
                if(calc.sorted_types().length){
                    
                    return calc.sorted_types().map((obj, i) => (
                        
                        <TypeSwitcher key={"CrTypeSwitcher" + i} obj={obj} />
                    ));
                }
            })()}
        
        </div>
    )
}


interface Props {
    obj: CalculatorLimit | undefined | {}
}



const TypeSwitcher: React.FC<Props> = ({obj}) => {
    const {t} = useTranslation()
    const local_limit = obj as CalculatorLimit
    const calc = useCalc()
    const selected = calc.get_selected_type() as CalculatorLimit
    
    return (
        <div
            className={clsx(
                styles.sw_item,
                styles[local_limit.category_name],
                (selected?.category_name === local_limit.category_name && Object.keys(local_limit).length) && styles.selected
            )}
            onClick={() => {
                calc.type_handle(local_limit)
            }}
        >
            <div className={styles.sw_item_inner}>
                {t(local_limit.category_name)}
            </div>
            
            <div className={styles.check}>
            
            </div>
        
        </div>
    )
}


export default SwitcherMobile